module.exports = __webpack_public_path__ + "static/feature-insights-adf6f80d17522818da7c5879c15a5d5a.png";